"use client";

import { useActionState, useState } from "react";
import { VStack } from "@astryxdesign/core/VStack";
import { HStack } from "@astryxdesign/core/HStack";
import { Card } from "@astryxdesign/core/Card";
import { Heading } from "@astryxdesign/core/Heading";
import { Text } from "@astryxdesign/core/Text";
import { TextInput } from "@astryxdesign/core/TextInput";
import { Button } from "@astryxdesign/core/Button";
import { Link } from "@astryxdesign/core/Link";
import { Banner } from "@astryxdesign/core/Banner";
import { forgotPasswordAction, type FormState } from "../actions";
import { WEBMCP_PARAMS, webmcpParam } from "@/lib/webmcp/forms";

const initialState: FormState = { status: "idle" };

export default function ForgotPasswordPage() {
  const [state, formAction, pending] = useActionState(
    forgotPasswordAction,
    initialState,
  );
  const [email, setEmail] = useState("");

  if (state.status === "success") {
    return (
      <>
        <Heading level={1} type="display-3">
          Проверьте почту
        </Heading>
        <Banner status="success" title={state.message ?? ""} container="card" />
        <HStack gap={1} justify="center">
          <Text color="secondary">Вспомнили пароль?</Text>
          <Link href="/login">Войти</Link>
        </HStack>
      </>
    );
  }

  const accountNotFound = state.hint === "register";

  return (
    <>
      <VStack gap={2} align="start">
        <Heading level={1} type="display-3">
          Сброс пароля
        </Heading>
        <Text color="secondary">
          Укажите email аккаунта — пришлём ссылку для установки нового пароля.
        </Text>
      </VStack>

      {state.status === "error" && state.message ? (
        <Banner status="error" title={state.message} container="card" />
      ) : null}

      <Card padding={6} width="100%">
        <form
          action={formAction}
          toolname="requestPasswordReset"
          tooldescription="Запросить ссылку для сброса пароля аккаунта Идеалитика на указанный email."
        >
          <VStack gap={4}>
            <TextInput
              type="email"
              label="Email"
              htmlName="email"
              value={email}
              onChange={setEmail}
              placeholder="you@company.ru"
              status={
                state.fieldErrors?.email
                  ? { type: "error", message: state.fieldErrors.email }
                  : undefined
              }
              isRequired
              hasAutoFocus
              {...webmcpParam(WEBMCP_PARAMS.accountEmail)}
            />
            <Button
              label="Отправить ссылку"
              variant="primary"
              type="submit"
              size="lg"
              isLoading={pending}
            />
          </VStack>
        </form>
      </Card>

      <HStack gap={1} justify="center">
        {accountNotFound ? (
          <>
            <Text color="secondary">Нет аккаунта?</Text>
            <Link href="/register">Зарегистрироваться</Link>
          </>
        ) : (
          <>
            <Text color="secondary">Вспомнили пароль?</Text>
            <Link href="/login">Войти</Link>
          </>
        )}
      </HStack>
    </>
  );
}
